import { render } from "./PriceView.vue?vue&type=template&id=05f4eb70&scoped=true&lang=pug"
import script from "./PriceView.vue?vue&type=script&lang=js"
export * from "./PriceView.vue?vue&type=script&lang=js"

import "./PriceView.vue?vue&type=style&index=0&id=05f4eb70&scoped=true&lang=scss"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f4eb70"]])

export default __exports__